import { useCallback, useState } from 'react';

import { useNavigate } from '@utils/hooks';
import { NotificationData } from '@utils/types';

import { userActions, useStore } from '@modules';
import { BillingAddressParams } from '@modules/user/types';

import validateBillingAddress from '@pages/BillingAddress/validateBillingAddress';

const useUpdateBillingAddressFromKYC = ({
  redirectTo,
  notificationData,
}: {
  redirectTo: string;
  notificationData: NotificationData;
}) => {
  const navigate = useNavigate();
  const [_, dispatch] = useStore();
  const [isLoading, setIsLoading] = useState(false);

  const handleRedirect = useCallback(
    (address?: BillingAddressParams) => {
      navigate<'billingAddress'>(CONST.nav.profileBillingAddress, {
        state: {
          redirectTo,
          notificationData,
          address,
        },
      });
    },
    [notificationData]
  );

  const updateBillingAddressFromKYC = useCallback(async () => {
    let isAddressUpdated = false;

    try {
      setIsLoading(true);
      const resKyc = await dispatch(userActions.getKycAddress()).unwrap();
      if (!resKyc.data) return handleRedirect();

      if (validateBillingAddress(resKyc.data)) {
        await dispatch(userActions.editUser({ billing_address: resKyc.data })).unwrap();
        isAddressUpdated = true;
        await dispatch(userActions.getUserData()).unwrap();
      } else {
        handleRedirect(resKyc.data);
      }
    } finally {
      setIsLoading(false);
    }

    return isAddressUpdated;
  }, []);

  return { updateBillingAddressFromKYC, isLoading };
};

export default useUpdateBillingAddressFromKYC;
